import { createStyles } from '../../../../../styles/helpers'

export default createStyles({
  carousel: {
    display: 'flex',
    padding: 10,
    paddingTop: 0
  }
})
